import React from "react";
import { colorFor, initials } from "../utils/format";

function CompanyLogo({ name, size = 40 }) {
  return (
    <div
      className="company-logo"
      style={{ width: size, height: size, background: colorFor(name), fontSize: size * 0.4 }}
      aria-hidden="true"
    >
      {initials(name) || "?"}
    </div>
  );
}

export default CompanyLogo;
